<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@addNewLogo">Add New Logo</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialogIcon" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <div class="mb-24 d-flex img-container">
    @if (imagesList.length<1) {
      <div (click)="addImage()" class="add-rectangle cursor d-inline-flex justify-content-center align-items-center" i18n-aria-label="@@addImage" aria-label="Add image">
        <mat-icon class="add-icon" i18n-aria-label="@@addIcon" aria-label="Add logo">add</mat-icon>
      </div>
    }
    @for (img of imagesList; track img; let i = $index) {
      <div  class="d-inline-flex align-items-center ml-8">
        <img [src]="img" width="200" height="200" i18n-alt="@@logoImageAlt" alt="Logo image"/>
        <mat-icon (click)="deleteImage(i)" color="warn" class="delete-icon cursor" i18n-aria-label="@@deleteImage" aria-label="Delete image">cancel</mat-icon>
      </div>
    }
  </div>
  @if (invalidImages) {
    <div i18n="@@invalidImageMessage" class="error">Please add image to proceed</div>
  }
  <form [formGroup]="addLogoForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@Title"> Title</mat-label>
        <input  matInput id="title" i18n-placeholder="@@Title" placeholder="Title" name="title" formControlName="title" required />
        <mat-error>
          @if (!addLogoForm.get('title').valid && addLogoForm.get('title').touched) {
            @if (addLogoForm.get('title').errors && addLogoForm.get('title').errors['required'] || addLogoForm.get('title').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>

    </div>
    <mat-dialog-actions>
      <button i18n="@@add" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Add</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>